import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Textarea,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

interface Props {
  modo: 'new' | 'view';
  data?: any;
  onGuardado?: () => void;
  onCancelar?: () => void;
}

const FormularioApoyo: React.FC<Props> = ({ modo, data, onGuardado, onCancelar }) => {
  const [form, setForm] = useState<any>({
    beneficiarioId: '',
    tipo: '',
    descripcion: '',
    monto: '',
    fechaSolicitud: '',
    estatus: 'pendiente',
    docs: '',
  });
  const [guardando, setGuardando] = useState(false);
  const [artesanos, setArtesanos] = useState<any[]>([]);

  useEffect(() => {
    axiosInstance.get('/turismo/artesanos').then((res) => setArtesanos(res.data || [])).catch(() => setArtesanos([]));
  }, []);

  useEffect(() => {
    if (data) {
      setForm({
        beneficiarioId: data.beneficiarioId || '',
        tipo: data.tipo || '',
        descripcion: data.descripcion || '',
        monto: data.monto || '',
        fechaSolicitud: data.fechaSolicitud ? data.fechaSolicitud.split('T')[0] : '',
        estatus: data.estatus || 'pendiente',
        docs: Array.isArray(data.docs) ? data.docs.join(', ') : data.docs || '',
      });
    }
  }, [data]);

  const handleChange = (field: string, value: any) => {
    setForm((prev: any) => ({ ...prev, [field]: value }));
  };

  const toArray = (value: string) =>
    value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);

  const handleSubmit = async () => {
    if (!form.tipo || !form.monto || !form.fechaSolicitud) return;
    setGuardando(true);
    try {
      const payload = {
        ...form,
        beneficiarioId: form.beneficiarioId ? Number(form.beneficiarioId) : null,
        docs: form.docs ? toArray(form.docs) : [],
      };
      if (modo === 'new') {
        await axiosInstance.post('/turismo/apoyos', payload);
      }
      onGuardado && onGuardado();
    } finally {
      setGuardando(false);
    }
  };

  const disabled = modo === 'view';

  return (
    <Box>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormControl>
          <FormLabel>Beneficiario</FormLabel>
          <Select value={form.beneficiarioId} onChange={(e) => handleChange('beneficiarioId', e.target.value)} isDisabled={disabled}>
            <option value="">Sin asignar</option>
            {artesanos.map((a) => (
              <option key={a.id} value={a.id}>{a.nombres} {a.apellidos}</option>
            ))}
          </Select>
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Tipo</FormLabel>
          <Input value={form.tipo} onChange={(e) => handleChange('tipo', e.target.value)} isDisabled={disabled} />
        </FormControl>
        <FormControl>
          <FormLabel>Descripcion</FormLabel>
          <Textarea value={form.descripcion} onChange={(e) => handleChange('descripcion', e.target.value)} isDisabled={disabled} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Monto</FormLabel>
          <Input type="number" value={form.monto} onChange={(e) => handleChange('monto', e.target.value)} isDisabled={disabled} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Fecha solicitud</FormLabel>
          <Input type="date" value={form.fechaSolicitud} onChange={(e) => handleChange('fechaSolicitud', e.target.value)} isDisabled={disabled} />
        </FormControl>
        <FormControl>
          <FormLabel>Estatus</FormLabel>
          <Select value={form.estatus} onChange={(e) => handleChange('estatus', e.target.value)} isDisabled={disabled}>
            <option value="pendiente">Pendiente</option>
            <option value="autorizado">Autorizado</option>
            <option value="rechazado">Rechazado</option>
          </Select>
        </FormControl>
        <FormControl>
          <FormLabel>Docs (coma)</FormLabel>
          <Textarea value={form.docs} onChange={(e) => handleChange('docs', e.target.value)} isDisabled={disabled} />
        </FormControl>
      </SimpleGrid>

      {modo !== 'view' && (
        <Box mt={6} display="flex" gap={3} justifyContent="flex-end">
          <Button onClick={onCancelar} variant="outline">Cancelar</Button>
          <Button bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={handleSubmit} isLoading={guardando} loadingText="Guardando">Guardar</Button>
        </Box>
      )}
    </Box>
  );
};

export default FormularioApoyo;

